import { render, staticRenderFns } from "./rateAllocationList.vue?vue&type=template&id=7aa5a99b&scoped=true"
import script from "./rateAllocationList.vue?vue&type=script&lang=js"
export * from "./rateAllocationList.vue?vue&type=script&lang=js"
import style0 from "./rateAllocationList.vue?vue&type=style&index=0&id=7aa5a99b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa5a99b",
  null
  
)

export default component.exports